import React, { FC } from 'react';
import classNames from 'classnames';

import { modalContentStyles } from './styles.css';

type ModalContentProps = {
  className?: string;
};

const ModalContent: FC<ModalContentProps> = ({ className, ...props }) => (
  <div className={classNames(modalContentStyles, className)} {...props} />
);

export default ModalContent;
